var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAssistantCoachHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.5585 38.3181C30.5459 38.5342 32.3602 37.1085 32.576 35.0781C32.792 33.0908 31.3664 31.2765 29.336 31.0607C27.3486 30.8446 25.5343 32.2703 25.3185 34.3007C25.1024 36.2877 26.5281 38.1021 28.5585 38.3181Z",
    fill: "url(#paint0_linear_4611_223902)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6971 52.0554H19.9211C19.6185 52.0554 19.3594 52.3146 19.3594 52.6171V54.0858C19.3594 54.3884 19.6185 54.6475 19.9211 54.6475H27.6971C27.9996 54.6475 28.2588 54.3884 28.2588 54.0858V52.6171C28.2154 52.3146 27.9993 52.0554 27.6971 52.0554Z",
    fill: "url(#paint1_linear_4611_223902)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7217 36.0283C35.389 36.0283 33.4882 37.9292 33.4882 40.2618C33.4882 40.4779 33.5313 40.6506 33.5313 40.8666L31.5873 42.0762C31.5873 42.0762 28.9952 39.7436 28.7361 39.5706C28.4335 39.3115 27.9586 39.1385 27.7425 39.0523C27.2673 38.8797 26.6194 38.5771 25.7552 38.2749C24.4591 37.7997 23.3361 38.6636 22.9904 39.7436C22.6447 40.8667 20.5278 47.3467 20.5278 47.3467C20.3551 48.1242 20.5709 48.945 21.0461 49.5498C21.5644 50.1546 22.2988 50.5002 23.0765 50.5002H28.9517C29.3405 50.5002 29.643 50.8028 29.643 51.1915V58.4924C29.643 59.5293 30.4639 60.3933 31.5439 60.3933C32.5808 60.3933 33.4448 59.5293 33.4448 58.4924L33.4451 49.4636C33.4451 47.9514 32.2355 46.7419 30.7234 46.7419H27.3969L28.3904 43.761L30.2479 45.4458C30.5504 45.705 30.9822 45.878 31.371 45.878C31.6735 45.878 31.9758 45.7915 32.2783 45.6188L35.2592 43.7614C35.9505 44.2366 36.7714 44.5388 37.6783 44.5388C40.011 44.5388 41.9119 42.6379 41.9119 40.3053C41.9122 37.9723 40.0547 36.0284 37.7218 36.0284L37.7217 36.0283ZM37.7217 42.8539C36.2961 42.8539 35.173 41.6874 35.173 40.3052C35.173 38.9226 36.3394 37.7565 37.7217 37.7565C39.1473 37.7565 40.2704 38.923 40.2704 40.3052C40.2707 41.6874 39.1473 42.8539 37.7217 42.8539Z",
    fill: "url(#paint2_linear_4611_223902)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7244 39.2686C37.1627 39.2686 36.6875 39.7438 36.6875 40.3054C36.6875 40.8671 37.1627 41.3423 37.7244 41.3423C38.286 41.3423 38.7613 40.8671 38.7613 40.3054C38.7613 39.7438 38.286 39.2686 37.7244 39.2686Z",
    fill: "url(#paint3_linear_4611_223902)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9959 38.9229C51.0263 38.9229 52.6681 37.3246 52.6681 35.2942C52.6681 33.2638 51.0697 31.6221 49.0393 31.6221C47.0089 31.6221 45.3672 33.2204 45.3672 35.2508C45.3672 37.2381 47.0089 38.9229 48.9959 38.9229Z",
    fill: "url(#paint4_linear_4611_223902)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M38.76 31.6651C39.8831 31.6651 40.9631 31.3626 41.8704 30.8012L44.3329 31.9243C44.8946 32.1835 45.4561 31.6218 45.1969 31.0604L44.0304 28.5978C44.5487 27.6905 44.8943 26.6105 44.8943 25.4874C44.8943 22.0748 42.1295 19.353 38.7599 19.353C35.3473 19.353 32.6255 22.1178 32.6255 25.4874C32.5824 28.9004 35.3472 31.6652 38.7599 31.6652L38.76 31.6651ZM42.2161 24.4074C42.8208 24.4074 43.2961 24.8826 43.2961 25.4874C43.2961 26.0921 42.8208 26.5674 42.2161 26.5674C41.6113 26.5674 41.1361 26.0921 41.1361 25.4874C41.093 24.8826 41.6113 24.4074 42.2161 24.4074ZM38.76 24.4074C39.3648 24.4074 39.84 24.8826 39.84 25.4874C39.84 26.0921 39.3648 26.5674 38.76 26.5674C38.1552 26.5674 37.68 26.0921 37.68 25.4874C37.6369 24.8826 38.1552 24.4074 38.76 24.4074ZM35.3039 24.4074C35.9087 24.4074 36.3839 24.8826 36.3839 25.4874C36.3839 26.0921 35.9087 26.5674 35.3039 26.5674C34.6991 26.5674 34.2239 26.0921 34.2239 25.4874C34.1808 24.8826 34.6991 24.4074 35.3039 24.4074Z",
    fill: "url(#paint5_linear_4611_223902)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8828 56.5052L54.5628 54.4748L54.3037 52.4875C54.9085 52.3148 55.4268 51.9692 55.8159 51.494C56.2911 50.8892 56.5071 50.0684 56.3775 49.2908C55.6432 44.7117 55.0384 41.8604 54.6063 40.8236C53.9581 39.4411 52.3164 38.8363 50.6747 39.4411C49.033 40.0459 48.0395 41.9036 47.6938 42.3785C47.4777 42.7242 47.1755 43.2424 47.0025 43.3289C46.5273 43.545 44.7129 43.9768 43.6329 44.2363C42.6825 44.4523 42.0777 45.4028 42.2938 46.3963C42.4665 47.2172 43.2012 47.7788 44.0217 47.7788C44.1512 47.7788 44.2808 47.7788 44.4104 47.7357C44.8856 47.6062 47.3913 47.0445 48.2982 46.6557C48.5143 46.5693 48.7304 46.4397 48.903 46.3101L49.5509 49.0318L45.7492 49.4639C44.6692 49.5935 43.8918 50.5439 43.9779 51.5808L44.3667 58.4929C44.4098 59.5729 45.3171 60.3938 46.3971 60.3938H46.5266C47.6498 60.3507 48.514 59.3569 48.4275 58.2338L48.1693 53.2653L50.2861 53.0062L50.6749 56.1166C50.7614 56.8079 51.1932 57.4127 51.8414 57.7149L57.1549 60.2205C57.414 60.3501 57.7166 60.3932 58.0188 60.3932C58.7962 60.3932 59.531 59.9611 59.8762 59.2267C60.3515 58.2332 59.9193 57.0236 58.8827 56.5053L58.8828 56.5052Z",
    fill: "url(#paint6_linear_4611_223902)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4611_223902",
    x1: 25.2969,
    y1: 34.6894,
    x2: 32.5976,
    y2: 34.6894,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8261C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#35B795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4611_223902",
    x1: 19.3594,
    y1: 53.3515,
    x2: 28.2588,
    y2: 53.3515,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8261C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#35B795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4611_223902",
    x1: 20.4687,
    y1: 48.2108,
    x2: 41.9119,
    y2: 48.2108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8261C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#35B795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4611_223902",
    x1: 36.6875,
    y1: 40.3054,
    x2: 38.7613,
    y2: 40.3054,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8261C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#35B795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4611_223902",
    x1: 45.3672,
    y1: 35.2725,
    x2: 52.6681,
    y2: 35.2725,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8261C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#35B795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4611_223902",
    x1: 32.625,
    y1: 25.6712,
    x2: 45.2619,
    y2: 25.6712,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8261C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#35B795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_4611_223902",
    x1: 42.25,
    y1: 49.8004,
    x2: 60.0687,
    y2: 49.8004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8261C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#35B795"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssistantCoachHover);
export default __webpack_public_path__ + "static/media/Assistant Coach Hover.e15296f3054b50a853260c0a496a005f.svg";
export { ForwardRef as ReactComponent };